var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCalendarIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4656_142047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20V4C22 3.73478 21.8946 3.48043 21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3H17V1H15V3H9V1H7V3ZM20 9V19H4V9H20ZM18 11H16V13H18V11ZM13 11H11V13H13V11Z",
    fill: "#758AB9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 2,
    height: 2,
    fill: "#758AB9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11,
    width: 2,
    height: 2,
    fill: "#758AB9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4656_142047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendarIcon.e1aa473b.svg";
export { ForwardRef as ReactComponent };